import { Box, Link, Typography } from "@mui/material";

type IProps = {
  title: string;
  description?: string;
  my?: number;
  isLink?: boolean;
  sameTab?: boolean;
  isTel?: boolean;
  linkTitle?: string;
};

const Info: React.FC<IProps> = ({
  title,
  description,
  my = 1.5,
  isLink = false,
  sameTab = false,
  isTel = false,
  linkTitle = ""
}) => {
  return (
    <Box sx={{ display: "flex", my }}>
      <Typography
        variant="body1"
        component="p"
        color="primary"
        sx={{ fontWeight: "700", mr: 1, fontSize: 18 }}
      >
        {title}:
      </Typography>
      {description &&
        (isLink ? (
          <Link
            sx={{ fontSize: 18, lineBreak: "anywhere" }}
            href={isTel ? `tel:${description}` : description}
            title={linkTitle}
            target={sameTab ? "_self" : "_blank"}
          >
            {description}
          </Link>
        ) : (
          <Typography variant="body1" component="p" sx={{ fontSize: 18 }}>
            {description}
          </Typography>
        ))}
    </Box>
  );
};

export default Info;
